import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useProjects } from '../useProjects/useProjects'
import { IProjectStatus } from '~/@api/generated-api-types-project/Api'

function useArchivedProjectsQuery() {
  const { fetchProjects } = useProjects([
    IProjectStatus.Finished,
    IProjectStatus.Funded,
  ])

  return useQuery({
    queryKey: ['archived-projects'],
    queryFn: fetchProjects,
    // throwOnError: true,
    placeholderData: keepPreviousData,
  })
}

export { useArchivedProjectsQuery }
